.wrap {
  display: grid;
  gap: 32px;
  padding-top: 16px;
}

.heading {
  margin: 0 0 14px;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 28px;
  line-height: 1.15;
  color: var(--text);
}

.columns {
  display: grid;
  gap: 8px 32px;
}

.list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 8px;
  font-size: 15px;
  line-height: 1.55;
}

.list li {
  position: relative;
  padding-left: 26px;
}

.yes::before,
.no::before,
.dot::before {
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  text-align: center;
  font-weight: 600;
}

.yes::before {
  content: '✓';
  color: var(--label);
}

.no::before {
  content: '✕';
  color: var(--text-muted);
}

.no {
  color: var(--text-secondary);
}

.dot::before {
  content: '•';
  color: var(--label);
}

@media (min-width: 768px) {
  .columns {
    grid-template-columns: 1fr 1fr;
  }
}
